// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".credit-card-icon[data-v-40247f3a]{position:relative;overflow:hidden;border-radius:4px;height:35px;width:50px}.credit-card-icon img[data-v-40247f3a]{width:50px;height:auto;background-color:#fff;margin:auto;position:absolute;top:0;bottom:0;left:0;right:0}", ""]);
// Exports
module.exports = exports;
